import { ValuesOf } from '../../types';

import { ServiceTypes } from '../../constants';

type TypeArg = Partial<ValuesOf<ServiceTypes>>;

interface BuildIsServiceFn {
  <L extends Partial<ReadonlyArray<TypeArg>>>(validServices: L): {
    <T extends TypeArg>(type: T): boolean;
  };
}

const buildIsServiceFn: BuildIsServiceFn = (validServices) => (type) =>
  validServices.includes(type);

export default buildIsServiceFn;
